import { render } from "./BaseCopyButton.vue?vue&type=template&id=7021e845&scoped=true"
import script from "./BaseCopyButton.vue?vue&type=script&lang=js"
export * from "./BaseCopyButton.vue?vue&type=script&lang=js"

import "./BaseCopyButton.vue?vue&type=style&index=0&id=7021e845&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7021e845"]])

export default __exports__